"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.EtherPaymentFallback__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var ethers_1 = require("ethers");
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address"
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256"
            },
        ],
        name: "SafeReceived",
        type: "event"
    },
    {
        stateMutability: "payable",
        type: "receive"
    },
];
var _bytecode = "0x6080604052348015600f57600080fd5b50607a8061001e6000396000f3fe608060405236603f5760405134815233907f3d0ce9bfc3ed7d6862dbb28b2dea94561fe714a1b4d019aa8af39730d1ad7c3d9060200160405180910390a2005b600080fdfea26469706673582212206668e4bbb6dbe9946d5abf6185d84ed61591f832b74855b1faa773814fcf81f764736f6c63430008110033";
var isSuperArgs = function (xs) { return xs.length > 1; };
var EtherPaymentFallback__factory = /** @class */ (function (_super) {
    __extends(EtherPaymentFallback__factory, _super);
    function EtherPaymentFallback__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        return _this;
    }
    EtherPaymentFallback__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    EtherPaymentFallback__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    EtherPaymentFallback__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    EtherPaymentFallback__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    EtherPaymentFallback__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    EtherPaymentFallback__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    EtherPaymentFallback__factory.bytecode = _bytecode;
    EtherPaymentFallback__factory.abi = _abi;
    return EtherPaymentFallback__factory;
}(ethers_1.ContractFactory));
exports.EtherPaymentFallback__factory = EtherPaymentFallback__factory;
